import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from '~/shared/constants/legalConstants'
import { eventLogger } from '~/shared/services/eventLogger'
import { selectIsLegalComplianceCountry } from '~/shared/store/user/selects'

import { AgeLegalConsentStyles as S } from './AgeLegalConsent.styles'

export const AgeLegalConsent = () => {
  const isLegalComplianceCountry = useSelector(selectIsLegalComplianceCountry)

  if (!isLegalComplianceCountry) return null

  return (
    <S.Text>
      <Trans
        ns="common"
        i18nKey="commonComponents.ageLegalConsent"
        components={{
          terms: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              aria-label="Terms of Service"
              href={TERMS_OF_SERVICE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => eventLogger.logTermsOfUseClicked()}
            />
          ),
          privacy: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              aria-label="Privacy Policy"
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => eventLogger.logPrivacyPolicyClicked()}
            />
          ),
        }}
      />
    </S.Text>
  )
}
